import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import FilterIcon from '../../../assets/FilterIcon';
import Dialog from '../../Dialog/components/Dialog';
import QueryBuilder from '../../QueryBuilder/QueryBuilder';
import { useFilter } from '../components/FilterContext';
import FilterList from '../components/FilterList';
import { Filter } from '../filter-state';

const PREFIX = 'FilterView';

const classes = {
  button: `${PREFIX}-button`,
  icon: `${PREFIX}-icon`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.button}`]: { float: 'right', whiteSpace: 'nowrap' },

  [`& .${classes.icon}`]: {
    marginRight: theme.spacing(1)
  }
}));

interface FilterListViewProps {
  disabled: boolean;
  elementId?: string;
}

const FilterView = ({ disabled, elementId = '' }: FilterListViewProps) => {
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);
  const [selectedFilter, setSelectedFilter] = React.useState<Filter | undefined>(undefined);
  const [isOpen, setIsOpen] = React.useState(false);
  const [filterToDelete, setFilterToDelete] = React.useState<null | Filter>(null);

  const onClose = () => {
    setIsOpen(false);
  };

  const { getFilters, toggleFilterSelect, removeFilter, addOrUpdateFilter } = useFilter();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  const openEditor = (filter: Filter | undefined) => {
    setSelectedFilter(filter);
    setIsOpen(true);
  };

  const handleDelete = async (filter: Filter) => removeFilter(filter);

  const onSubmit = async (filter: Filter) => addOrUpdateFilter(filter);

  const openDialog = (filter: Filter) => {
    setFilterToDelete(filter);
  };

  const closeDialog = () => {
    setFilterToDelete(null);
    if (handleClose) handleClose();
  };

  const clickDelete = () => {
    if (handleDelete && filterToDelete !== null) {
      handleDelete(filterToDelete);
    }
    closeDialog();
    setIsOpen(false);
  };

  return (
    <Root>
      <Button
        className={classes.button}
        color="inherit"
        data-testid="filter-button"
        onClick={handleClick}
        disabled={disabled}
      >
        <FilterIcon className={classes.icon} />
        FILTER
      </Button>
      <FilterList
        anchorElement={anchorElement}
        filters={getFilters()}
        handleClose={handleClose}
        handleSelect={toggleFilterSelect}
        handleDelete={openDialog}
        openEditor={openEditor}
      />
      <QueryBuilder
        filter={selectedFilter}
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={onSubmit}
        onDelete={openDialog}
        elementId={elementId}
      />
      {filterToDelete && (
        <Dialog
          isOpen
          content={{
            title: 'Delete filter?',
            text: (
              <>
                <span style={{ display: 'block' }}>
                  Are you sure you want to delete filter ' {filterToDelete.name}
                  '?
                </span>
                <span>This action cannot be undone.</span>
              </>
            )
          }}
          onClose={closeDialog}
          onConfirm={clickDelete}
        />
      )}
    </Root>
  );
};

export default FilterView;
